import {injectReducer} from '../../store/reducers'
import { isLoggedIn } from 'utils/auth'

export default (store) => ({
  path: 'CampaignEfficiency',
  onEnter: isLoggedIn(store),
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      const CampaignEfficiency = require('./containers/CampaignEfficiencyContainer').default;
      var homeReducers = require('./modules/CampaignEfficiency');
      const campaignReducer = homeReducers.campaignReducer;
      const campaignSpreadReducers = require('components/CampaignSpread/reducers');
      const campaignViewsReducers = require('components/CampaignViews/reducers');
      const campaignSpreadReducer = campaignSpreadReducers.campaignSpreadReducer;
      const userReducer = campaignSpreadReducers.userReducer;
      const viewsUserReducer = campaignViewsReducers.userReducer;
      const campaignViewsReducer = campaignViewsReducers.campaignViewsReducer;

      injectReducer(store, { key: 'campaigns', reducer: campaignReducer });
      injectReducer(store, { key: 'customers', reducer: campaignSpreadReducer });
      injectReducer(store, { key: 'viewedCustomers', reducer: campaignViewsReducer });
      injectReducer(store, { key: 'users', reducer: userReducer });
      injectReducer(store, { key: 'viewedUsers', reducer: viewsUserReducer });

      /*  Return getComponent   */
      cb(null, CampaignEfficiency)

      /* Webpack named bundle   */
    }, 'CampaignEfficiency')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CampaignEfficiency/index.js